export interface CityData {
  name: string;
  lat: number;
  lng: number;
}

export interface LocationData {
  slug: string;
  name: string;
  state: string;
  region: string;
  description: string;
  highlights: string[];
  content: string[];
  isPrimary: boolean;
  lat: number;
  lng: number;
  cities: CityData[];
}

export const locations: LocationData[] = [
  {
    slug: "plymouth",
    name: "Plymouth",
    state: "IN",
    region: "Marshall County",
    isPrimary: true,
    lat: 41.3434,
    lng: -86.3097,
    description:
      "Yessica Cleaning and Painting LLC is based in Plymouth, IN. We clean and paint homes and businesses across Marshall County and the surrounding region — Monday through Friday, 7 AM to 5:30 PM.",
    highlights: [
      "Headquartered on Michigan Rd in Plymouth, IN",
      "Cleaning, painting & pressure washing",
      "Residential and commercial work",
      "25% off for returning customers",
    ],
    content: [
      "Plymouth is our home base. We know these neighborhoods — from downtown Michigan Street to the subdivisions off Jefferson and the county roads out toward Lake Latonka. We bring our own supplies, equipment, and a plan built around your property.",
      "Homeowners in Plymouth call us for recurring house cleaning, move-in and move-out cleans, interior repaints, cabinet refinishing, and deck and driveway pressure washing. Local businesses count on us for office cleaning and storefront painting scheduled around their hours.",
      "Call (305) 748-3036 for a free, no-pressure estimate in Plymouth today.",
    ],
    cities: [
      { name: "Bourbon", lat: 41.2959, lng: -86.1155 },
      { name: "Argos", lat: 41.2381, lng: -86.2461 },
      { name: "Bremen", lat: 41.4467, lng: -86.1481 },
      { name: "Culver", lat: 41.2181, lng: -86.4231 },
    ],
  },
  {
    slug: "bremen",
    name: "Bremen",
    state: "IN",
    region: "Marshall County",
    isPrimary: false,
    lat: 41.4467,
    lng: -86.1481,
    description:
      "Cleaning, interior and exterior painting, and pressure washing in Bremen, IN. Same-week scheduling available for homes and small businesses.",
    highlights: [
      "Same-week scheduling in Bremen",
      "House cleaning & recurring plans",
      "Interior & exterior painting",
      "Free written estimates",
    ],
    content: [
      "Bremen is just up the road from our Plymouth shop, so we're there often. We handle everything from weekly house cleaning to full interior repaints and deck refinishing.",
      "Local homeowners hire us for kitchen cabinet refinishing and exterior siding painting — both projects that make a house feel new without a remodel budget. Businesses along Plymouth Street use us for recurring cleaning.",
      "Call (305) 748-3036 to book a free estimate in Bremen.",
    ],
    cities: [
      { name: "Wyatt", lat: 41.5117, lng: -86.1078 },
      { name: "Lakeville", lat: 41.5228, lng: -86.2761 },
      { name: "Plymouth", lat: 41.3434, lng: -86.3097 },
    ],
  },
  {
    slug: "culver",
    name: "Culver",
    state: "IN",
    region: "Marshall County",
    isPrimary: false,
    lat: 41.2181,
    lng: -86.4231,
    description:
      "Culver, IN cleaning and painting services. Lake homes, seasonal properties, rentals, and year-round residences — inside and out.",
    highlights: [
      "Lake Maxinkuckee home specialists",
      "Seasonal & rental turnover cleaning",
      "Deck, porch & dock railing painting",
      "Pressure washing for patios & siding",
    ],
    content: [
      "Culver's lake properties need a different kind of care. Seasonal homes around Lake Maxinkuckee get opened, closed, cleaned between guests, and repainted after hard winters — and we handle all of it.",
      "We pressure wash decks, patios, and siding, then repaint porches, railings, and exterior trim so lake homes look sharp all season. Rental owners use us for fast, reliable turnover cleaning.",
      "Call (305) 748-3036 for a free Culver estimate.",
    ],
    cities: [
      { name: "Lake Maxinkuckee", lat: 41.2, lng: -86.4 },
      { name: "Monterey", lat: 41.1795, lng: -86.4808 },
      { name: "Rutland", lat: 41.2472, lng: -86.4622 },
    ],
  },
  {
    slug: "south-bend",
    name: "South Bend",
    state: "IN",
    region: "St. Joseph County",
    isPrimary: false,
    lat: 41.6764,
    lng: -86.2520,
    description:
      "South Bend's trusted cleaning and painting company. House cleaning, commercial cleaning, interior and exterior painting, and pressure washing across the city.",
    highlights: [
      "Residential & commercial cleaning",
      "Interior & exterior house painting",
      "Rental & student housing turnovers",
      "Driveway & siding pressure washing",
    ],
    content: [
      "South Bend is one of our busiest service areas. We clean and paint homes across the near northwest side, River Park, Harter Heights, and the neighborhoods around Notre Dame.",
      "Landlords and property managers rely on us for turnover cleaning and quick interior repaints between tenants. Homeowners hire us for cabinet refinishing, full-house interiors, and exterior siding and porch painting.",
      "Get your free South Bend quote at (305) 748-3036.",
    ],
    cities: [
      { name: "River Park", lat: 41.6721, lng: -86.2 },
      { name: "Notre Dame", lat: 41.7002, lng: -86.2379 },
      { name: "Roseland", lat: 41.7175, lng: -86.2422 },
      { name: "New Carlisle", lat: 41.7017, lng: -86.5108 },
    ],
  },
  {
    slug: "mishawaka",
    name: "Mishawaka",
    state: "IN",
    region: "St. Joseph County",
    isPrimary: false,
    lat: 41.6620,
    lng: -86.1586,
    description:
      "Mishawaka, IN cleaning and painting. Homes, condos, offices, and storefronts — cleaned, painted, and pressure washed by a local team.",
    highlights: [
      "Recurring house & office cleaning",
      "Interior painting & cabinet refinishing",
      "Deck, fence & porch painting",
      "Pressure washing for concrete & siding",
    ],
    content: [
      "Mishawaka homeowners call us for interior repaints, kitchen cabinet refinishing, and recurring house cleaning. Businesses along Grape Road and Main Street use us for office and retail cleaning after hours.",
      "We also handle a lot of exterior work here — decks, fences, porches, and siding that need washing and a fresh coat before winter.",
      "Book your free Mishawaka estimate at (305) 748-3036.",
    ],
    cities: [
      { name: "Osceola", lat: 41.6656, lng: -86.0736 },
      { name: "Granger", lat: 41.7472, lng: -86.1108 },
      { name: "Elkhart", lat: 41.6819, lng: -85.9767 },
    ],
  },
  {
    slug: "goshen",
    name: "Goshen",
    state: "IN",
    region: "Elkhart County",
    isPrimary: false,
    lat: 41.5820,
    lng: -85.8344,
    description:
      "Goshen, IN cleaning and painting services for homes and businesses. Interior painting, cabinet refinishing, deep cleaning, and pressure washing.",
    highlights: [
      "House & commercial cleaning",
      "Interior & exterior painting",
      "Cabinet & trim refinishing",
      "25% returning-customer discount",
    ],
    content: [
      "Goshen's mix of historic homes and newer builds keeps us busy. Older houses here often need careful prep work — scraping, patching, and priming — before paint goes on, and we don't cut that step short.",
      "We clean homes on weekly and bi-weekly schedules, handle move-out cleans, and paint interiors and exteriors for homeowners and small businesses throughout Elkhart County.",
      "Call (305) 748-3036 for free Goshen pricing.",
    ],
    cities: [
      { name: "Millersburg", lat: 41.5259, lng: -85.6961 },
      { name: "New Paris", lat: 41.5006, lng: -85.8261 },
      { name: "Middlebury", lat: 41.6745, lng: -85.7053 },
    ],
  },
  {
    slug: "la-porte",
    name: "La Porte",
    state: "IN",
    region: "LaPorte County",
    isPrimary: false,
    lat: 41.6106,
    lng: -86.7136,
    description:
      "La Porte, IN cleaning and painting company. Residential and commercial cleaning, interior and exterior painting, and pressure washing.",
    highlights: [
      "Residential & commercial cleaning",
      "Full interior & exterior painting",
      "Lake home & seasonal property care",
      "Driveway & patio pressure washing",
    ],
    content: [
      "La Porte homes — including the lake properties around Pine Lake and Stone Lake — get the same detail-driven care we bring to every job. We clean, paint, and pressure wash inside and out.",
      "Seasonal owners use us to open and close properties, refresh interiors between rentals, and repaint decks and porches that take a beating over the winter.",
      "Reach us at (305) 748-3036 for a free La Porte estimate.",
    ],
    cities: [
      { name: "Michigan City", lat: 41.7075, lng: -86.895 },
      { name: "Pine Lake", lat: 41.6275, lng: -86.7167 },
      { name: "Rolling Prairie", lat: 41.6706, lng: -86.6011 },
    ],
  },
  {
    slug: "valparaiso",
    name: "Valparaiso",
    state: "IN",
    region: "Porter County",
    isPrimary: false,
    lat: 41.4731,
    lng: -87.0611,
    description:
      "Valparaiso, IN cleaning and painting. Homes, offices, and rentals cleaned, painted, and pressure washed by a bilingual local team.",
    highlights: [
      "House & office cleaning",
      "Interior painting & cabinet refinishing",
      "Exterior siding, deck & porch painting",
      "Free written estimates",
    ],
    content: [
      "Valparaiso homeowners hire us for full-house interior painting, kitchen cabinet refinishing, and recurring cleaning that keeps up with busy families.",
      "We also work with offices and small businesses downtown and along US-30, scheduling cleaning and painting outside business hours so nothing gets interrupted.",
      "Call (305) 748-3036 to book in Valparaiso.",
    ],
    cities: [
      { name: "Wheeler", lat: 41.4914, lng: -87.1497 },
      { name: "Chesterton", lat: 41.6106, lng: -87.0531 },
      { name: "Kouts", lat: 41.3117, lng: -87.0281 },
    ],
  },
  {
    slug: "portage",
    name: "Portage",
    state: "IN",
    region: "Porter County",
    isPrimary: false,
    lat: 41.5759,
    lng: -87.1761,
    description:
      "Portage, IN cleaning and painting services. Residential cleaning, interior and exterior painting, cabinet refinishing, and pressure washing.",
    highlights: [
      "Recurring residential cleaning",
      "Interior & exterior painting",
      "Garage & basement painting",
      "Concrete & siding pressure washing",
    ],
    content: [
      "Portage families use us for weekly and bi-weekly house cleaning, and for the projects that keep getting pushed off — painting the garage, refinishing cabinets, washing years of grime off the driveway.",
      "We handle commercial cleaning here too, from small offices to retail spaces along Willowcreek and US-20.",
      "Get your free Portage quote at (305) 748-3036.",
    ],
    cities: [
      { name: "Ogden Dunes", lat: 41.6175, lng: -87.1936 },
      { name: "Burns Harbor", lat: 41.6303, lng: -87.1281 },
      { name: "Lake Station", lat: 41.5753, lng: -87.2389 },
    ],
  },
  {
    slug: "crown-point",
    name: "Crown Point",
    state: "IN",
    region: "Lake County",
    isPrimary: false,
    lat: 41.4170,
    lng: -87.3653,
    description:
      "Crown Point, IN cleaning and painting. Detail-focused house cleaning, interior and exterior painting, cabinet refinishing, and pressure washing.",
    highlights: [
      "House & commercial cleaning",
      "Interior painting & trim work",
      "Cabinet & railing refinishing",
      "Deck, patio & driveway washing",
    ],
    content: [
      "Crown Point's newer subdivisions and historic square homes both keep us busy. We paint interiors, refinish cabinets and stair railings, and clean homes on recurring schedules.",
      "Exterior season brings deck refinishing, siding washing, and porch painting — all prepped properly so the finish holds up through a Lake County winter.",
      "Call (305) 748-3036 for a free Crown Point estimate.",
    ],
    cities: [
      { name: "Winfield", lat: 41.4067, lng: -87.2761 },
      { name: "Cedar Lake", lat: 41.3661, lng: -87.4411 },
      { name: "Merrillville", lat: 41.4828, lng: -87.3328 },
    ],
  },
  {
    slug: "munster",
    name: "Munster",
    state: "IN",
    region: "Lake County",
    isPrimary: false,
    lat: 41.5645,
    lng: -87.5125,
    description:
      "Munster, IN cleaning and painting company. Residential and commercial cleaning, interior and exterior painting, and pressure washing.",
    highlights: [
      "Residential & commercial cleaning",
      "Interior painting & cabinet refinishing",
      "Exterior siding & trim painting",
      "25% off for returning customers",
    ],
    content: [
      "Munster homeowners bring us in for interior repaints, cabinet refinishing, and cleaning they can count on week after week. We show up when we say we will and we protect your space while we work.",
      "Offices and medical suites along Calumet Avenue and Ridge Road use our commercial cleaning, scheduled around patients and staff.",
      "Book your free Munster estimate at (305) 748-3036.",
    ],
    cities: [
      { name: "Highland", lat: 41.5539, lng: -87.4519 },
      { name: "Griffith", lat: 41.5281, lng: -87.4237 },
      { name: "Schererville", lat: 41.4789, lng: -87.4548 },
    ],
  },
  {
    slug: "dyer",
    name: "Dyer",
    state: "IN",
    region: "Lake County",
    isPrimary: false,
    lat: 41.4939,
    lng: -87.5217,
    description:
      "Dyer, IN cleaning and painting services. Homes, offices, and rentals — cleaned, painted, and pressure washed inside and out.",
    highlights: [
      "House & office cleaning",
      "Interior & exterior painting",
      "Move-in / move-out cleans",
      "Free written estimates",
    ],
    content: [
      "Dyer sits at the western edge of our service map and we cross it regularly. Homeowners here hire us for full interior painting, deep cleans, and exterior projects like deck refinishing and siding washing.",
      "Recurring cleaning customers in Dyer get consistent crews, a consistent checklist, and 25% off returning service.",
      "Call (305) 748-3036 for free Dyer pricing.",
    ],
    cities: [
      { name: "St. John", lat: 41.4506, lng: -87.4714 },
      { name: "Schererville", lat: 41.4789, lng: -87.4548 },
      { name: "Highland", lat: 41.5539, lng: -87.4519 },
    ],
  },
  {
    slug: "niles-mi",
    name: "Niles",
    state: "MI",
    region: "Berrien County",
    isPrimary: false,
    lat: 41.8298,
    lng: -86.2539,
    description:
      "Niles, MI cleaning and painting. Residential and commercial cleaning, interior and exterior painting, and pressure washing just across the state line.",
    highlights: [
      "House & commercial cleaning",
      "Interior & exterior painting",
      "Historic home prep & repaints",
      "Pressure washing for siding & concrete",
    ],
    content: [
      "Niles is a short drive from South Bend and a regular stop for our crew. The historic homes here need patient prep work before painting, and we take the time to do it right.",
      "We handle recurring house cleaning, move-out cleans, cabinet refinishing, and full exterior repaints throughout Berrien County.",
      "Get your free Niles, MI estimate at (305) 748-3036.",
    ],
    cities: [
      { name: "Buchanan", lat: 41.8275, lng: -86.3617 },
      { name: "Berrien Springs", lat: 41.9464, lng: -86.3439 },
      { name: "Edwardsburg", lat: 41.7953, lng: -86.0803 },
    ],
  },
  {
    slug: "three-oaks-mi",
    name: "Three Oaks",
    state: "MI",
    region: "Berrien County",
    isPrimary: false,
    lat: 41.7986,
    lng: -86.6086,
    description:
      "Three Oaks, MI cleaning and painting services. Seasonal homes, rentals, and year-round residences cleaned, painted, and pressure washed.",
    highlights: [
      "Vacation rental turnover cleaning",
      "Interior & exterior painting",
      "Porch, deck & railing refinishing",
      "Seasonal property care",
    ],
    content: [
      "Three Oaks and the Harbor Country area are full of second homes and short-term rentals that need reliable turnover cleaning and regular exterior upkeep. That's exactly what we do.",
      "We repaint porches, decks, and railings, wash siding and patios, and refresh interiors between seasons so properties are guest-ready.",
      "Call (305) 748-3036 for a free Three Oaks estimate.",
    ],
    cities: [
      { name: "New Buffalo", lat: 41.7942, lng: -86.7442 },
      { name: "Sawyer", lat: 41.8961, lng: -86.6072 },
      { name: "Galien", lat: 41.7936, lng: -86.4972 },
    ],
  },
  {
    slug: "three-rivers-mi",
    name: "Three Rivers",
    state: "MI",
    region: "St. Joseph County, MI",
    isPrimary: false,
    lat: 41.9436,
    lng: -85.6325,
    description:
      "Three Rivers, MI cleaning and painting. Interior and exterior painting, house and commercial cleaning, and pressure washing for every property type.",
    highlights: [
      "Residential & commercial cleaning",
      "Interior & exterior painting",
      "Cabinet & trim refinishing",
      "Deck & driveway pressure washing",
    ],
    content: [
      "Three Rivers rounds out our Michigan service area. We paint interiors and exteriors, refinish cabinets, and keep homes and small businesses clean on recurring schedules.",
      "Exterior work here includes deck refinishing, siding washing, and porch painting — with full prep before any paint goes on.",
      "Book your free Three Rivers, MI estimate at (305) 748-3036.",
    ],
    cities: [
      { name: "Constantine", lat: 41.8397, lng: -85.6683 },
      { name: "Centreville", lat: 41.9203, lng: -85.5261 },
      { name: "White Pigeon", lat: 41.7986, lng: -85.6428 },
    ],
  },
];

export const primaryLocation = locations.find((l) => l.isPrimary) ?? locations[0];
